export default class RequestFormCrmIntegration {

    linkExisting    : boolean = false
    createNew       : boolean = false

    constructor(data: any) {
        this.linkExisting   = _.get(data, 'linkExisting', false)
        this.createNew      = _.get(data, 'createNew', false)
    }

    toJSON(): JSONObject {
        return {
            linkExisting: this.linkExisting,
            createNew   : this.createNew
        }
    }
}